/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tag_Picker_No_MatchInputs */



/**
* | output |
* | --- |
* | "No matching tags" |
*
* @param {Project_Tag_Picker_No_MatchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_picker_no_match = /** @type {((inputs?: Project_Tag_Picker_No_MatchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Picker_No_MatchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine passenden Tags")
	return /** @type {LocalizedString} */ ("No matching tags")
});